/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:18:01
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-08-19 18:18:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/tools.ts
 */
import _ from 'lodash';
import { linkValidation } from 'src/constrains/DraggableModules/tools';
import {
  //   useErrorOnChange,
  //   useErrorOnChange2,
  convertSpecificError,
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from 'src/error/code';
import {
  fixedCollapse,
  generateDefaultGridSetting,
  generateDefaultProductMenu,
  generateDefaultTopLeaderBoardBanner,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/common';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import { EnumCollapseId } from './slice';

const topLeaderBoardBannerValidation = (data) => {
  const generalError = [];
  const specificErr = {};
  const { enabled } = data || {};
  if (!enabled) {
    return {
      hasError: false,
      specificError: specificErr,
      generalError,
    };
  } else {
    // specificErr = linkImgValidation({
    //   data: linkModule,
    //   err: specificErr,
    //   suffixKey: '',
    // });
    return {
      hasError: convertSpecificError(specificErr).length > 0,
      specificError: specificErr,
      generalError,
    };
  }
};

const menuValidation = (data, isPrimary) => {
  const generalError = [];
  let specificErr = {};
  const { enabled, roots = [] } = data || {};
  if (!enabled) {
    return {
      hasError: false,
      specificError: specificErr,
      generalError,
    };
  } else {
    if (isPrimary) {
      if (roots.length < 1) {
        generalError.push(errCodesMap['999992']);
      }
      roots.map((root) => {
        specificErr = linkValidation({
          data: root.linkModule,
          err: specificErr,
          suffixKey: '',
        });
      });
    }
    return {
      hasError: generalError.length > 0,
      specificError: specificErr,
      generalError,
    };
  }
};

const convertDataFromServerToRedux = (data, isPrimary) => {
  const {
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    topLeaderBoardBanner,
    menu,
    hasError,
    modifiedDate,
    createdDate,
    miniProgramShare,
    miniProgramPageInfo,
    gridSetting,
    translationEnabled = false,
  } = data;
  const isNew = modifiedDate == createdDate;
  const collapseOpen = generateCollapseOpen(fixedCollapse);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    fixedCollapse,
    !isNew,
  );
  const _topLeaderBoardBanner = generateDefaultTopLeaderBoardBanner();
  const _productMenu = generateDefaultProductMenu();
  const _a = {
    collapseOpen,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    topLeaderBoardBanner: topLeaderBoardBanner || _topLeaderBoardBanner,
    productMenu: menu || _productMenu,
    uuid,
    collapseErrorMsgDisplay,
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
    gridSetting: gridSetting || generateDefaultGridSetting(),
    translationEnabled,
    ...reduxUpdatedStatusControl,
  };

  if (!isNew && hasError) {
    let flag = false;
    const { hasError: topLeaderBoardBannerHasError } =
      topLeaderBoardBannerValidation(_a.topLeaderBoardBanner);
    if (topLeaderBoardBannerHasError) {
      _a.collapseErrorMsgDisplay[EnumCollapseId.topLeaderBoardBanner].hasError =
        true;
      _a.collapseErrorMsgDisplay[EnumCollapseId.topLeaderBoardBanner].display =
        true;

      _a.collapseOpen[EnumCollapseId.topLeaderBoardBanner] = true;
      flag = true;
    }
    const { hasError: productMenuHasError } = menuValidation(
      _a.productMenu,
      isPrimary,
    );

    if (productMenuHasError) {
      _a.collapseErrorMsgDisplay[EnumCollapseId.productMenu].hasError = true;
      _a.collapseErrorMsgDisplay[EnumCollapseId.productMenu].display = true;
      if (!flag) {
        _a.collapseOpen[EnumCollapseId.productMenu] = true;
        flag = true;
      }
    }
  }

  return _a;
};

const convertDataFromReduxToServer = (data) => {
  const _state = _.cloneDeep(data);
  const {
    contentUuid,
    uuid,
    topLeaderBoardBanner,
    productMenu,
    miniProgramShare,
    gridSetting,
  } = _state;
  const { enabled: topE } = topLeaderBoardBanner;
  const { enabled: menuE } = productMenu;
  return {
    topLeaderBoardBanner: topE ? topLeaderBoardBanner : { enabled: false },
    contentUuid,
    menu: menuE ? productMenu : { enabled: false },
    uuid,
    miniProgramShare,
    gridSetting,
  };
};

export {
  topLeaderBoardBannerValidation,
  convertDataFromReduxToServer,
  menuValidation,
  convertDataFromServerToRedux,
};
